export const cardType = {
  stats_leads: 'info',
  stats_active: 'warning',
  stats_success: 'success',
  stats_failed: 'error'
}

export const textType = {
  stats_leads: 'default',
  stats_active: 'warning',
  stats_success: 'success',
  stats_failed: 'danger'
}

export const stats = [
  'stats_leads',
  'stats_active',
  'stats_success',
  'stats_failed'
]
